import { render, staticRenderFns } from "./ModalTab.vue?vue&type=template&id=72b6d402&"
import script from "./ModalTab.vue?vue&type=script&lang=js&"
export * from "./ModalTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports